import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgFeedAlt = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M22 3H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM5 6a1 1 0 0 1 1-1h7v8H5V6zm0 9v7a1 1 0 0 0 1 1h7v-8H5zm10 0v8h7a1 1 0 0 0 1-1v-7h-8zm8-2V6a1 1 0 0 0-1-1h-7v8h8z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFeedAlt;
